import BurgerInHandIcon from 'components/icons/burger-in-hand';

export const LoggedOutEmptyStateImage = BurgerInHandIcon;
